import {
  API_ERROR,
  MENU,
  INPUT_CHANGEVALUE,
  MENU_LIST_SUCCESSFUL,
  MENU_ADD,
  MENU_ADD_SUCCESSFUL,
  MENU_ROW_DATA,
  MENU_ROW_DATA_SUCCESSFUL,
  MENU_DELETE,
  MENU_SETROWDATA,
  MODEL_OPEN,
  MODEL_CLOSE,
} from "./actionTypes";

const initialState = {
  error: "Sorry! No Data Found.",
  message: null,
  loading: false,
  MenusList: [],
  model: false,
  error_msg: null,
  rowdata: {},
};

const SubLocation = (state = initialState, action) => {
  switch (action.type) {
    case MENU:
      state = {
        ...state,
        loading: true,
      };
      break;
    case MENU_LIST_SUCCESSFUL:
      state = {
        ...state,
        MenusList: action.payload.results,
        loading: false,
      };
      break;
    case INPUT_CHANGEVALUE:
      state = {
        ...state,
        rowdata: {
          ...state.rowdata,
          [action.payload.key]: action.payload.value,
        },
      };
      break;

    case MENU_ADD:
      state = {
        ...state,
        loading: false,
      };
      break;
    case MENU_ADD_SUCCESSFUL:
      state = {
        ...state,
        // message: action.payload,
        loading: false,
        model: false,
        rowdata: { Id: 0 },
      };
      break;
    case MENU_ROW_DATA:
      state = {
        ...state,
        model: true,
        // rowdata: action.payload,
      };
      break;
    case MENU_ROW_DATA_SUCCESSFUL:
      state = {
        ...state,
        loading: false,
        rowdata: action.payload,
      };
      break;
    case MENU_DELETE:
      state = {
        ...state,
        loading: false,
      };
      break;
    case MENU_SETROWDATA:
      state = {
        ...state,
        rowdata: action.payload,
        // model: true,
      };
      break;
    case MODEL_OPEN:
      state = {
        ...state,
        model: true,
      };
      break;
    case MODEL_CLOSE:
      state = {
        ...state,
        model: false,
        rowdata: { id: 0 },
      };
      break;
    case API_ERROR:
      state = {
        ...state,
        loading: false,
        error_msg: action.payload,
      };
      break;

    default:
      state = { ...state };
      break;
  }
  return state;
};

export default SubLocation;
